import React from 'react'
import BasicInfoCreate from './BasicInfoCreate'
import Basicinfo from './Basicinfo'

function BasicInfoCreateEdit(props) {
  const {
    section,
    activeSection,
    handleSectionClick,
    setActiveSection,
    PersoninputData,
    personName,
    personNamete,
    error,
    setInputData,
    sendValueChangedBoolean,
    shortBio,
    shortBiote,
    setShortBio,
    setShortBiote,
    setPersonNamete,
    setPersonName,
    setWikipediaURL,
    valueChanged,
    wikipediaURL,
    personData,
    fetchPersonData,
    setLoader,
    mode,
  } = props
  return (
    <>
      {mode === 'create' && (
        <BasicInfoCreate
          section={section}
          activeSection={activeSection}
          handleSectionClick={sectionId =>
            handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
          }
          PersoninputData={PersoninputData}
          personName={personName}
          personNamete={personNamete}
          error={error}
          sendInputPersondata={setInputData}
          sendValuechangedBoolean={sendValueChangedBoolean}
          shortBio={shortBio}
          shortBiote={shortBiote}
          setShortbio={setShortBio}
          setShortbiote={setShortBiote}
          setpersonNamete={setPersonNamete}
          setpersonName={setPersonName}
          setWikipediaURL={setWikipediaURL}
          valueChanged={valueChanged}
          updateInputPersonData={(fieldname, fieldvalue) => {
            setInputData(prevData => ({
              ...prevData,
              [fieldname]: fieldvalue,
            }))
          }}
          wikipediaURL={wikipediaURL}
          personData={personData}
          getUpdatedData={fetchPersonData}
          setLoader={setLoader}
          mode={mode}
        />
      )}
      {mode === 'edit' && (
        <Basicinfo
          section={section}
          activeSection={activeSection}
          handleSectionClick={sectionId =>
            handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
          }
          PersoninputData={PersoninputData}
          personName={personName}
          personNamete={personNamete}
          error={error}
          sendInputPersondata={setInputData}
          sendValuechangedBoolean={sendValueChangedBoolean}
          shortBio={shortBio}
          shortBiote={shortBiote}
          setShortbio={setShortBio}
          setShortbiote={setShortBiote}
          setpersonNamete={setPersonNamete}
          setpersonName={setPersonName}
          setWikipediaURL={setWikipediaURL}
          valueChanged={valueChanged}
          updateInputPersonData={(fieldname, fieldvalue) => {
            setInputData(prevData => ({
              ...prevData,
              [fieldname]: fieldvalue,
            }))
          }}
          wikipediaURL={wikipediaURL}
          personData={personData}
          getUpdatedData={fetchPersonData}
          setLoader={setLoader}
        />
      )}
    </>
  )
}

export default BasicInfoCreateEdit
